import type ToastNotificationState from "./state";

export enum ToastNotificationEnum {
    INFO = 'info',
    ERROR = 'error',
}

export type State = ReturnType<typeof ToastNotificationState>;
